var _defs, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _g2, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _text17, _text18, _text19, _text20, _text21, _text22, _text23, _text24, _text25, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 480,
    width: 640,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d5dfff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474747",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f50",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    y2: 173.45,
    xlinkHref: "#a",
    gradientUnits: "userSpaceOnUse",
    x2: 110.94,
    gradientTransform: "matrix(1.5 0 0 .65 40.51 .01)",
    y1: 218.47,
    x1: 109.34
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    y2: 337.23,
    gradientUnits: "userSpaceOnUse",
    x2: 126.02,
    gradientTransform: "matrix(1.23 0 0 .8 40.51 .01)",
    y1: 316.38,
    x1: 125.91
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b50000",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc500",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    y2: 147.35,
    xlinkHref: "#b",
    gradientUnits: "userSpaceOnUse",
    x2: 456.4,
    gradientTransform: "matrix(.56 0 0 1.76 40.51 .01)",
    y1: 149.38,
    x1: 407.87
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    y2: 102.99,
    xlinkHref: "#a",
    gradientUnits: "userSpaceOnUse",
    x2: 228.97,
    gradientTransform: "matrix(.74 0 0 1.33 40.51 .01)",
    y1: 102.99,
    x1: 215.83
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    y2: 1003.7,
    xlinkHref: "#b",
    gradientUnits: "userSpaceOnUse",
    x2: 78.221,
    gradientTransform: "matrix(2.56 0 0 .38 40.51 .01)",
    y1: 1040.4,
    x1: 117.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    y2: 226.38,
    xlinkHref: "#b",
    gradientUnits: "userSpaceOnUse",
    x2: 255.03,
    gradientTransform: "matrix(.9 0 0 1.1 40.51 .01)",
    y1: 245.98,
    x1: 264.72
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#006",
    d: "M0 0h640v480H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0v32.946l403.223 261.736h50.755v-32.945L50.755 0H0zm453.978 0v32.945L50.755 294.68H0v-32.944L403.223 0h50.755z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M189.157 0v294.68h75.663V0h-75.663zM0 98.227v98.227h453.978V98.227H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c00",
    d: "M0 117.872v58.937h453.978V117.87H0zM204.29 0v294.68h45.398V0H204.29zM0 294.68l151.326-98.226h33.836L33.836 294.68H0zM0 0l151.326 98.227H117.49L0 21.965V0zm268.816 98.227L420.142 0h33.836L302.652 98.227h-33.836zM453.978 294.68l-151.326-98.226h33.836l117.49 76.263v21.964z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M463.75 349.947s-2.878 7.61-4.523 7.61c-1.646 0-7.61-3.29-7.61-3.29s-4.32 6.99-6.58 7.403c-2.263.41-8.227-1.03-8.227-1.03s-5.758 0-5.964-.82c-.206-.824.206-2.47.206-2.47s-8.227 6.582-10.078 6.17c-1.85-.41-8.02-8.226-8.02-8.226l-1.03 4.123-11.723-.413-10.283-6.584s-5.758 9.46-5.964 9.255c-.205-.206-10.077 2.262-10.077 2.262l-.617-1.85-6.582-3.908s5.14-7.2 5.14-7.405c0-.205-2.467-1.028-2.467-1.028l-3.7 3.085-7.61 4.935-7.61-3.496 3.292-6.168.41-4.525 5.965-9.05 73.008-70.95 35.99 66.427-5.347 19.948z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.147,
    fill: "#6a4c2d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M515.62 354.25l19.003-.682-8.09-3.996 72.41-2.73-10.232-3.897-9.063-12.28-37.52-2.826s-2.827-2.145-7.407-1.073c-.195-2.923-3.704-6.724-3.704-6.724l-23.097-1.754-14.425 9.842 9.746 24.948 12.378 1.17z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.147,
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M121.32 150.76l2.224-7.561s3.892-6.562 3.892-9.453c0-2.892 2.89-6.34 2.89-6.34s8.897-2.557 10.787 2.892c9.563-14.457 20.794-.668 20.794-.668l3.114-3.67 6.34-7.783s9.006 8.45 9.117 9.895 1.557.445 1.557.445l9.786-.778s4.644 3.635 3.67 10.564c3.448 2.034 6.56 14.01 6.56 14.01l-80.73-1.556z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "url(#c)",
    transform: "matrix(.86 0 0 .86 337.27 11.7)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M515.505 218.72c1.45-.893 6.023-2.343 5.465-9.035-.557-6.692-6.357-7.473-9.592-7.25-3.235.223-6.135 3.01-6.135 3.01l-10.707-6.802s5.353-33.797 11.042-35.916c5.402-3.893 6.358-5.577 6.358-6.47s-2.008-3.122-2.008-3.122l-34.912-4.127L442 152.912s-2.564 3.904-2.23 5.465.446 3.235 6.358 7.808c6.54 5.03 11.042 33.908 11.042 33.908s-9.258 4.573-9.815 4.015c-.558-.557-3.346-1.115-4.796-.892-1.45.223-6.247 2.677-6.247 9.034 0 6.358 4.796 10.04 4.796 10.04s31.564-3.68 36.25 5.018c4.572-10.484 34.576-6.803 38.145-8.588z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: ".86pt",
    fill: "#656263"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M549.51 183.588s.35-3.67 2.97-5.415c2.62-1.747 20.088-2.62 24.28 0s5.765 15.547 5.765 15.547 2.62 4.542 2.795 7.86.524 5.59.524 5.59 13.975 18.168 14.15 34.588c1.572 11.18 1.222 41.05-3.145 52.405-.176 14.148-6.115 23.407-6.115 23.407s1.398 2.445 1.223 5.066c-.175 2.62-1.573 5.066-1.573 5.066l20.438 10.132-7.51-2.795s7.686 6.46 7.51 6.287c-.174-.175-8.56-4.018-8.56-4.018l5.067 5.065c-.175-.175-12.402-5.59-12.402-5.59s5.763 5.416 5.414 5.24c-.35-.174-9.258-4.367-9.258-4.367s5.59 5.94 5.416 5.59-8.036-3.493-8.036-3.493l.35 2.97s-6.29-.35-6.29-5.067c-3.143-1.747-5.24-4.192-5.24-4.192l-14.498-2.445-16.42-49.086 3.843-82.974 1.047-4.193-1.748-11.18z",
    strokeOpacity: 0.979,
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.075
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M538.536 448.752s-8.41-17.698-12.604-17.946c-3.784-7.212 13.15-66.187 45.907-69.55 18.01 1.485 1.48 20.763-10.36 14.83 1.478 5.19 7.4 12.605 7.4 12.605s-23.438 10.135-30.344 60.062z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.139,
    fill: "#fb0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M425.773 451.332s6.96-20.138 11.187-20.386c4.226-.25-11.187-67.126-44.75-67.623-18.148 1.492-1.49 20.883 10.442 14.917-1.49 5.22-7.458 12.68-7.458 12.68s23.618 10.192 30.58 60.412z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: ".86pt",
    fill: "#fb0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M456.56 325.54c-.08-.162-8.33 2.588-2.99 11.565.403-3.478 4.123-5.58 4.123-5.58s-5.66 6.712.324 12.373c.727-5.337 4.124-7.035 4.124-7.035s-4.204 12.373.082 14.88c.485-4.934 3.64-7.117 3.64-7.117s-3.802 11.08-.405 13.587c.404-4.205 3.235-6.066 3.235-6.066s-1.7 11.485 2.75 12.293c.08-4.043 3.315-8.006 3.315-8.006s-1.456 9.38 5.5 9.786c.08-3.56 1.375-7.603 1.375-7.603s3.154 9.948 7.763 8.33c-.08-2.91.08-8.41 0-8.41s2.912 9.462 8.41 7.683c-.807-2.67.325-5.824.325-5.824s2.912 5.904 8.17 3.963c.888-1.78-.245-5.257-.245-5.257s7.684 7.926 10.03 3.154c2.345-4.772-6.148-6.39-6.148-6.39h5.743s-1.86-4.85-9.625-5.903c2.67-1.213 5.42-.324 5.42-.324s-1.618-6.065-9.544-6.712c3.074-1.052 6.47-.324 6.47-.324s-1.05-5.74-9.785-7.36c1.376-1.536 5.095-1.05 5.095-1.05s-3.477-5.42-7.44-5.096-39.79-3.64-39.71-3.558z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: ".86pt",
    fill: "#00713d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M491.898 354.737s3.154 1.537 3.073 2.912m-1.207-5.415s4.044 2.83 3.963 4.933m-.411-6.395s3.235 2.022 3.397 5.177m2.021-3.879s1.618 3.48 1.05 4.125m2.192-2.267c.243 2.75-.243 2.992-.243 2.992m-39.635-20.38s3.8 2.425 3.478 5.822m-3.719-2.907s1.78 1.697 1.375 2.83m3.321-5.66s2.507 3.478 1.698 5.904m2.585-3.642s1.132 2.184.08 3.397m1.941-2.348s1.375 2.184.16 2.91m-1.691 4.288s3.558.81 4.044 3.478m-1.946-5.902s3.72.242 4.125 4.205m.811-5.582c.08 0 2.507 4.286 2.103 5.66m2.671-5.256s.97 4.125.242 5.418m2.828-3.801c0 .08.08 4.77.08 4.77m-4.767-11.237s2.345.89 2.183 3.154m-.007-5.261s2.992 1.7 2.668 4.934m.815-6.301s2.588 3.072 1.617 6.47m2.907-5.748s-.972 3.8-.568 5.338m3.318-2.749s-1.697 1.294-.808 2.912m-13.905 11.888s.565 2.91 0 3.396m-3.724-5.09s1.86 3.234 1.212 4.852m-5.177-5.015s2.103 2.426 2.022 4.367m-5.255-3.886s1.94 1.86 1.78 2.91m-3.475-.08s1.86 1.94 1.78 2.345",
    strokeWidth: 1.075,
    stroke: "#3ec26d",
    strokeLinecap: "round",
    fill: "none"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M430.89 222.21l26.748-.477s17.674 0 19.585 5.732c3.343-7.642 18.628-7.164 18.628-7.164 9.236-.317 18.47-.637 27.705-.955l.48 66.873c-5.415 25.953-24.203 44.263-44.902 52.065-24.68-7.962-40.283-28.82-45.378-52.543l-2.865-63.53z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: ".86pt",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M440.418 221.96l38.964 103.84 35.2-106.098c-10.918.704-34.347-1.72-37.258 8.244-4.503-8.917-29.15-5.322-36.906-5.982z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: ".86pt",
    fill: "#006b00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M466.94 278.18c1.5.784 1.458-28.18 3.426-29.08.563-2.398.845-3.448 1.547-5.996-1.687-2.998-9.28-2.848-12.09-.3 1.264 4.048 1.826 5.397 1.826 5.397 3.796 6.146 3.042 30.633 5.29 29.98z",
    fillRule: "evenodd",
    stroke: "#006b00",
    strokeLinecap: "round",
    strokeWidth: 0.593,
    fill: "#ffc900"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M456.5 54.31s2.753-3.127 2.878-3.877c.126-.75 12.512-1.25 19.893-15.014 4.13-7.258 0-3.004 0-3.004l-.25-3.503s5.13-4.88 3.255-7.507c-1.877-2.627-1.252 3.378-4.255 3.253-3.002-.126-1.376-6.507-1.376-6.507s-.25-.75-1.126-1.126c-1.25.125-.876 2.377-2.002 2.627-1.125.25-2.126-5.255-2.126-5.255s-1.877-2.503-3.504 5.38c.876 8.382 6.256 6.756 6.256 12.26 0 5.505-4.755 9.76-6.13 9.884-1.377.126-.877-4.63-.877-4.63s-.75-2.25-1.25-2.25 2.752-.5 2.252-6.757c-1.127-7.507-2.002 1.75-4.004 1.376s-.5-6.88.25-7.632-.876-3.877-5.255 4.13c-.375 3.88-.876-1-1.75-.75-1.503 3.127-1.253 5.38.874 8.257 3.128 2.877 5.13 5.755 5.005 7.256-.125 1.502-1.75 4.88-4.004 4.88s.125-4.13 0-5.505c-.125-1.376-3.878-6.38-3.878-6.38s-2.628-4.255-2.377-4.38c.25-.125-.25-.75-1.502 3.628s-2.753-2.877-2.753-2.877-1.75 5.38 2.002 8.63c-2.877-.374-3.128.752-3.128.752 0 1.502 3.88 2.127 4.38 4.754s-4.004 4.13-4.004 4.13 1.877 2.627 7.13-2.503c.127 3.253-2 5.505-2 5.505 1.75.792 3.127.71 3.377 2.753z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.075,
    fill: "#cdad56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M439.335 54.31s-2.338-3.47-2.444-4.154c-.105-.683-11.502.864-16.895-13.035-3.506-6.603 0-2.732 0-2.732l.213-3.187s-3.732-4.565-2.138-6.955c1.594-2.39.938 3.073 2.988 3.085 2.55-.114 1.168-5.92 1.168-5.92s.212-.684.957-1.025c1.062.114 1.494 3.54 2.452 3.767.955.228 2.93-4.03 3.557-4.907.875-.125.842-3.528 2.224 3.645-.744 7.627-7.064 6.147-7.064 11.156 0 5.01 4.038 8.88 5.206 8.994 1.17.114.744-4.212.744-4.212s.637-2.05 1.062-2.05c.426 0-3.713.796-3.29-4.896.958-5.33 3.078.343 4.778 0 1.7-.34-.2-5.635.288-6.443.113-.81 2.62-4.28 3.588 3.38.32 3.53 2.244-3.037 2.988-2.81 1.276 2.847-.564 6.648-2.37 9.266-2.656 2.62-3.856 5.488-3.75 6.854.106 1.366.737 3.063 2.65 3.063 1.913 0 .644-2.38.75-3.633.107-1.252 3.295-5.305 3.295-5.305.626-1 .106-2.87.77-3.735 1.037.01 1.462-1.434 2.525 2.55 1.062 3.986 2.337-2.617 2.337-2.617s1.488 4.895-1.7 7.855c2.445-.34 2.656.683 2.656.683 0 1.367-1.166 1.937-1.592 4.327-.425 2.39 1.273 3.757 1.273 3.757s-1.594 2.39-6.057-2.277c-.107 2.96 1.7 5.01 1.7 5.01-1.487.72-2.655.645-2.87 2.504z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 0.945,
    fill: "#cdad56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M508.083 237.45c-2.33-2.115-2.607-.267-3.754-.74-.562-.236-1.003-.762-1.49-1.24-.426-.437-.93-.617-1.492-.854l-.636 1.88c-.212.625.59 1.663.572 2.603-.16 1.396-.728 2.552-2.48 3.03.5-.99.782-1.038.63-2.246-.076-.604-1.765-1.675-1.557-2.247.31-.92.838-1.982.448-2.9-.72.492-1.66.234-2.38.534-.604.27-.645 1.395-1.486 1.863-.863.403-2.764.203-4.35-.698.97-.735 1.77-.24 2.74-.975.486-.368.464-1.944.95-2.312s1.645-.76 2.13-1.128c-.435-.497-.412-1.284-.848-1.78-.437-.497-2.37-.39-2.808-.887-.872-.993-.706-2.3-1.58-3.295 2.26.81 1.932 1.91 2.498 1.828 1.07-.513 2.138-.615 2.7-.38.56.237 1.63 1.633 2.19 1.87.212-.627.52-1.422.733-2.048.212-.627-.953-1.712-.74-2.34.423-1.25 1.476-2.358 1.9-3.61.152 1.207.353 2.223.505 3.43.076.605 1.263.918 1.34 1.523.075.605-.62 2.007-.545 2.61.65-.13 1.587-.04 2.235-.17.648-.13 1.08-1.637 1.727-1.766 1.297-.258 2.23-.18 3.552.07-.97.904-1.723.843-2.33 1.675-.486.367.188 1.58-1.215 2.432-.527.306-1.912-.062-2.397.306l1.308 1.49s2.396.728 2.832 1.225c.872.995 1.334 2.18 1.095 3.247zm-59.916 1.023c2.33-2.115 2.608-.268 3.754-.74.562-.237 1.003-.763 1.49-1.24.426-.437.93-.618 1.492-.854l.636 1.878s-.59 1.663-.572 2.603c.158 1.4.728 2.554 2.48 3.034-.5-.99-.782-1.04-.63-2.247.076-.604 1.765-1.675 1.557-2.248-.31-.918-.838-1.98-.448-2.9.72.492 1.66.235 2.38.533.604.27.645 1.394 1.486 1.862.863.404 2.764.204 4.35-.696-.97-.738-1.77-.24-2.74-.978-.486-.368-.463-1.943-.948-2.31-.486-.37-1.648-.76-2.133-1.13.436-.496.412-1.283.848-1.78.437-.496 2.37-.39 2.808-.886.872-.994.706-2.302 1.578-3.295-2.257.812-1.93 1.912-2.497 1.828-1.07-.512-2.137-.614-2.7-.378-.56.236-1.627 1.632-2.19 1.868-.21-.626-.52-1.422-.732-2.048-.212-.626.953-1.71.74-2.337-.423-1.253-1.476-2.36-1.9-3.613-.152 1.208-.353 2.223-.505 3.43-.076.605-1.264.92-1.34 1.524-.076.604.62 2.005.545 2.61-.65-.13-1.587-.042-2.235-.17-.648-.13-1.08-1.637-1.728-1.767-1.297-.26-2.23-.18-3.552.07.97.904 1.724.842 2.332 1.675.485.368-.19 1.58 1.213 2.433.526.305 1.913-.06 2.398.307l-1.31 1.49c-.435.496-2.394.728-2.83 1.225-.873.993-1.335 2.18-1.096 3.246z",
    fillRule: "evenodd",
    fill: "#ffc900"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M505.993 244.14c-2.11 1.65-15.747 5.096-15.887 16.938-.14 11.842 2.39 14.54-.14 14.84-4.922 0-5.625-13.19-5.484-19.036.14-5.847.28-4.947.28-4.947s3.374.9 3.094 3.748c-.28 2.847 3.374-7.045 2.11-9.744 2.248 2.248 5.2 1.348 5.2 1.198 0-.15-1.686-1.948-2.39-3.297-.702-1.35 2.532.75 2.532.75s.14-2.248-2.672-2.1c-3.655 0 .563-1.198.563-1.198s2.108 1.948 3.514-.15c-1.547-1.648-3.796-2.548-3.796-2.548s-1.97-3.747-4.64-4.496c-3.093-.75-2.672 1.348-6.187 1.05-.7 1.347-.7 1.498.705 1.947-2.39 1.65-1.125 4.947-1.125 4.947s3.796-1.65 3.655 1.05c-.14 2.697-2.25 2.248-3.655.6-1.265-.75-1.687.748-1.687.748l1.968 2.098s-3.796-.15-4.78 2.4c2.11-.15 3.235.45 3.235.45s-4.36 1.948-4.782 2.997c-.42 1.05-.56-1.2-.702-1.2-.14 0-4.217-1.498-4.217-1.498l-1.408 6.482s2.814 2.81 4.36 1.91c1.548-.9 4.36-3.597 6.046-2.848-4.92 3.748-9.84 9.144-12.512 9.894-.703-.6-3.093-2.998-4.077-1.8-.983 1.2-.28 2.7.985 2.55 1.265-.15-4.077 1.198-2.952 3.446 1.125 2.25.984 2.1 1.968 1.5.985-.6-.842-.75 2.813-1.8 3.655-1.048 3.514-2.098 3.514-2.098s-.702 1.65-2.67 2.1c-1.968.45-3.516.45-3.093 1.048.42.6 1.264 1.65.983 2.25-.28.598 4.078-3.15 5.203-.15 2.953-.15 4.92-3.748 3.514-5.847.14 2.248 1.547 2.997.703 4.047s6.608-3.448 2.952-6.146c.985 2.25 1.124 4.047 1.124 4.047s1.688-.15 2.11-.75c.42-.6-.844 1.65-.28 2.1.56.45 3.232 2.998 2.107 4.797-.7-1.05-.842-2.7-1.685-2.55-.845.15-4.36 2.7-6.468 2.85s2.53 7.794 2.53 7.794-3.234-.45-3.654-.15c-.422.3-2.53-2.698-2.953-.9-.704 2.25.702 1.35.702 1.35s-1.827-.9-2.81.15c-.985 1.05-1.97 2.098-1.267 2.547.703.45 3.797.45 4.218.3s-3.515.3-3.796.75c-.282.45-.843 2.1 0 2.7s2.953-.3 3.093-.75c.14-.45.282 1.65.282 1.65s3.655.298 3.655-3.45.282 2.7.282 2.7 3.654.598 3.794-3.15.422 2.55.422 2.55 2.39-.75 2.39-1.35c0-.6-.14 7.495-1.827 9.744-2.673-1.8-4.36 1.198-4.36 1.198s.14 4.348-.14 5.397c-.28 1.048 1.827-.6 1.968-1.05.14-.45 2.67-1.65 2.812-1.95l.843-1.798s-.563 2.098-1.546 2.398-1.97 1.35-1.548 2.25c.422.898 1.97 1.498 2.53 2.397.563.9 2.53-5.246 2.53-5.246l.142 1.35s2.53-.6 2.812-1.8c.28-1.198-2.67-2.247-.28-4.196 2.39-1.948 0 1.8 0 1.8s.842 2.847 1.405 2.847 1.966-5.395.56-6.745c-1.405-1.348 2.11 1.65 2.11 1.65s1.97-5.546-.14-6.296-3.094-1.05-3.094-1.05 1.125-1.5.563-1.65 2.95 3.3 3.513 2.4 1.407-3.6-2.67-5.097c-4.078-1.5-.14-5.697-.14-5.697s2.53 2.998 4.358 1.35c1.828-1.65-.14-1.65-.14-1.65s5.202-3.296 5.342-4.946c-.984-.15-2.67.15-2.67.15s2.952-1.948 2.25-5.096c-1.126 1.648-2.673 1.65-2.673 1.65s2.53-2.55 2.108-4.948c-1.546 1.2-1.406 2.098-2.39 1.8s-2.67-9.744 1.265-10.345c3.937-.597 1.828 4.65 1.97 4.65.14 0 5.904-2.4 0-6.297 1.405-.45 4.357 2.25 4.357 2.25s-1.265-6.598-7.592-2.55c1.547-1.648 2.53-2.698 3.796-2.398 1.266.3 5.766-.15 5.766-1.5-1.125-.9-3.516.45-4.782 0-1.265-.45 8.998-1.2 8.155-6.294z",
    fillRule: "evenodd",
    stroke: "#006b00",
    strokeLinecap: "round",
    strokeWidth: 0.593,
    fill: "#ffc900"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M481.3 118.54s12.247-6.43 18.37 1.53m4.9 12.25c-.306 0-4.286 3.98-5.205 3.98m13.475 8.88s11.328.918 18.676-10.41",
    transform: "matrix(.46 0 0 .5 240.33 190.12)",
    stroke: "#006b00",
    strokeLinecap: "round",
    strokeWidth: 1.25,
    fill: "none"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M525.08 141.81s.92 6.123 2.756 6.123-3.062 1.53-4.9.306c2.144 2.755 3.37 7.654 0 9.49",
    transform: "matrix(.46 0 0 .5 240.33 190.12)",
    stroke: "#006b00",
    strokeLinecap: "round",
    strokeWidth: 1.25,
    fill: "none"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M519.26 218.97s-3.98 4.286-8.88 4.592",
    fillRule: "evenodd",
    transform: "matrix(.46 0 0 .5 240.33 190.12)",
    stroke: "#006b00",
    strokeLinecap: "round",
    strokeWidth: 1.25,
    fill: "#e80000"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M523.86 199.37s-2.45-12.247-.92-15.31c.92-3.978 4.9-5.51 7.962-10.715m-8.272 17.145s-3.062 7.348-16.533 4.9m20.213-23.27s.92 9.797-11.328 6.123M511.3 128.04s-4.9 4.287-3.062 10.104",
    transform: "matrix(.46 0 0 .5 240.33 190.12)",
    stroke: "#006b00",
    strokeLinecap: "round",
    strokeWidth: 1.25,
    fill: "none"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M483.732 247.596s2.955-1.2 3.517-1.8c.562-.6 1.547-1.8 1.828-2.7.282-.9-1.97-2.25-.844-4.2.704-.9 1.688-1.05 3.377 0 1.69 1.05-1.547-3.3-3.235-3.45s-2.814 1.2-3.236.9c-.423-.3.14 1.2-.564 1.2s1.407 1.2 1.267 1.95c-.14.75 2.25 3.3 2.11 3.9-.14.6-3.517 4.05-4.22 4.2z",
    fillRule: "evenodd",
    fill: "#006b00"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M534.27 97.112c2.794-.636 3.243.07 2.755 2.45-1.31-.66-1.79-1.218-2.755-2.45z",
    fillRule: "evenodd",
    transform: "matrix(.46 0 0 .5 240.33 190.12)",
    stroke: "#ffc900",
    strokeLinecap: "round",
    strokeWidth: 1.25,
    fill: "#ffc900"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M514.71 233.52s-1.033 6.41 1.49 6.946c-.125-2.48.537-4.176 1.157-4.837-.538-.25-2.522-2.068-2.647-2.11zm-5.68-7.89c-2.316-.33-6.23 1.59-5.105 3.91 1.88-1.62 3.626.135 4.94-1.518.405-.453.29-1.812.165-2.392zm-.02-4.58s-3.65-.58-4.157 1.948c2.52-.32 3.274-.59 4.11-.06.24-.54.007-1.762.047-1.888z",
    fillRule: "evenodd",
    transform: "matrix(.46 0 0 .5 240.33 190.12)",
    stroke: "#006b00",
    strokeWidth: 1.25,
    fill: "#e80000"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M493.54 184.94s2.19.828 2.81 3.06c1.737-1.075 2.565-5.83-2.81-3.06zm-5.42 5.45c.083-.04 4.59-2.77 5.045-.165-.952.95-1.365 1.57-2.11 1.778-.578 0-1.736-1.778-2.935-1.613zm-.45 8.85c.082-.042 2.894-2.522 3.97-.868 1.074 1.653-.87 1.57-.87 1.57s-.992-.454-3.1-.702zm-3.97-49.28c-.04 0-3.597-1.364-5.085 1.116 2.357.29 3.184 1.117 4.258 1.944-.29-1.034-.785-2.605.827-3.06zm-6.9 18.56s.165-4.176 2.15-5.87c1.116.62 1.446 1.61 2.19 2.852-1.487.33-3.472.413-4.34 3.018zm9.5-2.98s-3.928 1.82-2.646 3.804c1.282-1.364 2.688-.95 2.688-.992s0-2.77-.042-2.812z",
    fillRule: "evenodd",
    transform: "matrix(.46 0 0 .5 240.33 190.12)",
    stroke: "#006b00",
    strokeWidth: "1pt",
    fill: "#e80000"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M480.64 125.6c-1.406 1.57 1.736 5.003 5.044 4.507.827-3.72-4.217-5.664-5.044-4.507z",
    fillRule: "evenodd",
    transform: "matrix(.46 0 0 .5 240.33 190.12)",
    stroke: "#006b00",
    strokeWidth: "1pt",
    fill: "#ffc900"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M461.183 248.13c-.317.857.943 2.06 1.672 1.72.297-.877-1.343-2.402-1.672-1.72z",
    fill: "none"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M484.28 122.75s.62 2.936 3.473 2.15c-.455-2.274-2.44-3.97-2.44-3.97-.123.663.414 1.696-1.033 1.82zm1.9 8.52s1.57 1.695 4.672-1.778c-1.405.413-3.886-.827-3.886-.827s0 2.398-.786 2.605z",
    fillRule: "evenodd",
    transform: "matrix(.46 0 0 .5 240.33 190.12)",
    stroke: "#006b00",
    strokeWidth: "1pt",
    fill: "#e80000"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M480.46 118.86c-1.406 1.57.583 3.762 3.89 3.266.828-3.72-3.063-4.423-3.89-3.266z",
    fillRule: "evenodd",
    transform: "matrix(.46 0 0 .5 240.33 190.12)",
    stroke: "#006b00",
    strokeWidth: "1pt",
    fill: "#ffc900"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M144.62 266.62s7.037-2.01 10.77 1.005 3.735.287 3.735.287 5.457 2.01 7.037 1.58-1.148.144 1.006-1.15c2.154-1.29-4.31.29-4.883-2.44-1.006-1.724.143-3.878-2.154-3.16-1.58-2.01 1.006-3.446.43-5.6-1.578 1.148-2.44-.432-3.733 2.44-3.015-.574-.43-4.74-3.734-5.17 0 3.016-2.442 3.16-2.585 4.883-1.436 1.006-7.755 4.74-5.888 7.325z",
    fillRule: "evenodd",
    fill: "url(#d)",
    transform: "matrix(.86 0 0 .86 337.27 11.7)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M391.987 437.9c3.926-.95 25.203 4.696 33.405 13.49-1.74-15.662-6.08-27.66-6.08-27.66s-12.68-3.618-14.42-1.877c-2.552 2.688-10.22 10.743-12.905 16.046zm-6.487-72.344c-1.49.248-2.983 1.243-4.474 3.73-1.74 4.225-2.984 14.915-5.47 17.402-2.486 2.486-4.724 2.734-4.724 4.972 0 2.237.25 7.458 6.962 9.447 6.712.25 17.403-10.69 17.403-10.69s5.47-5.967 7.706-12.43c-12.927 4.474-22.126-7.46-17.402-12.43z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: ".86pt",
    fill: "#c01500"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M572.47 435.405c-3.895-.943-25.417 4.67-33.556 13.413 1.728-15.57 6.034-27.5 6.034-27.5 1.502-.41 12.444-3.596 14.172-1.865 2.533 2.673 10.686 10.68 13.35 15.952zm6.03-71.922c1.48.247 2.004 2.192 3.212 4.663 1.726 4.2 3.506 10.322 5.974 12.793 2.466 2.472 4.687 6.133 4.687 8.358 0 2.223-.52 5.23-7.18 7.206-6.662.247-16.314-8.305-16.314-8.305s-5.428-5.934-7.65-12.36c12.83 4.45 21.138-7.005 17.27-12.357z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.139,
    fill: "#c01500"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M378.043 424.233s13.424 9.2 13.674 13.425c36.05-53.452 128.036-70.11 180.496-3.73 6.96-9.198 14.17-12.18 14.17-12.18-55.193-72.103-165.084-63.15-208.342 2.485z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: ".86pt",
    fill: "#fb0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    fillRule: "evenodd",
    fill: "#1e5aa6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M514.93 219.86l5.258-.124-9.39 11.893 11.27 13.145-22.162 27.92 20.91 25.166c-2.296 5.635-4.968 10.77-8.515 15.4l-12.018-13.27 21.785-27.17-17.904-20.282 10.767-32.677zm-75.12 2.376l-5.634.125 10.516 11.394-11.143 13.898 23.16 25.165-19.155 25.666c2.296 5.634 5.593 11.894 9.14 16.526l11.393-14.4-23.412-26.04 17.152-21.785-12.02-30.55z",
    strokeWidth: 1.147
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.85 289.844l-8.263 11.018 29.548 34.18c5.217-2.63 9.307-5.634 13.772-9.265l-15.4-17.78 6.26-18.404 9.015 10.392-28.17 35.933c-4.716-2.003-9.933-5.133-14.65-9.015l14.9-18.905-7.01-18.154zm-9.14-17.152l5.385 6.76-3.505-9.14-1.88 2.38z",
    strokeWidth: 1.147
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.274 278.673c.118-.125 4.345-5.76 4.345-5.76l-1.645-2.253-2.7 8.013z",
    strokeWidth: 1.111
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fontWeight: "bold",
    transform: "matrix(.56 -.65 .65 .56 337.27 11.7)",
    fontSize: 14,
    y: 362.397,
    x: -328.344,
    fontFamily: "Timmons"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 362.397,
    x: -328.344
  }, "L"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    fontWeight: "bold",
    transform: "matrix(.6 -.6 .6 .6 337.27 11.7)",
    fontSize: 14,
    y: 384.266,
    x: -292.335,
    fontFamily: "Timmons"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 384.266,
    x: -292.335
  }, "E"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    fontWeight: "bold",
    transform: "matrix(.66 -.47 .5 .65 337.27 11.7)",
    fontSize: 14,
    y: 451.681,
    x: -239.78,
    fontFamily: "Timmons"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 451.681,
    x: -239.78
  }, "O"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    fontWeight: "bold",
    transform: "matrix(.7 -.48 .48 .7 337.27 11.7)",
    fontSize: 14,
    y: 429.958,
    x: -188.526,
    fontFamily: "Timmons"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 429.958,
    x: -188.526
  }, "T"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    fontWeight: "bold",
    transform: "matrix(.78 -.37 .37 .78 337.27 11.7)",
    fontSize: 14,
    y: 451.479,
    x: -115.426,
    fontFamily: "Timmons"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 451.479,
    x: -115.426
  }, "E"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    fontWeight: "bold",
    transform: "matrix(.8 -.35 .35 .8 337.27 11.7)",
    fontSize: 14,
    y: 453.046,
    x: -94.111,
    fontFamily: "Timmons"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 453.046,
    x: -94.111
  }, "R"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    fontWeight: "bold",
    transform: "matrix(.8 -.32 .32 .8 337.27 11.7)",
    fontSize: 14,
    y: 454.982,
    x: -68.371,
    fontFamily: "Timmons"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 454.982,
    x: -68.371
  }, "R"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    fontWeight: "bold",
    transform: "matrix(.86 -.07 .07 .86 337.27 11.7)",
    fontSize: 14,
    y: 445.666,
    x: 112.016,
    fontFamily: "Timmons"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 445.666,
    x: 112.016
  }, "R"))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    fontWeight: "bold",
    transform: "matrix(.86 0 0 .86 337.27 11.7)",
    fontSize: 14,
    y: 430.793,
    x: 180.225,
    fontFamily: "Timmons"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 430.793,
    x: 180.225
  }, "R"))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    fontWeight: "bold",
    transform: "matrix(.75 .43 -.43 .75 337.27 11.7)",
    fontSize: 14,
    y: 275.217,
    x: 414.759,
    fontFamily: "Timmons"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 275.217,
    x: 414.759
  }, "R"))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    fontWeight: "bold",
    transform: "matrix(.66 .55 -.55 .66 337.27 11.7)",
    fontSize: 14,
    y: 193.05,
    x: 483.878,
    fontFamily: "Timmons"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 193.05,
    x: 483.878
  }, "E"))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    fontWeight: "bold",
    transform: "matrix(.83 .16 -.13 .82 337.27 11.7)",
    fontSize: 14,
    y: 414.028,
    x: 309.116,
    fontFamily: "Timmons"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 414.028,
    x: 309.116
  }, "O"))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    fontWeight: "bold",
    transform: "matrix(.78 -.1 .12 .84 337.27 11.7)",
    fontSize: 14,
    y: 459.272,
    x: 105.058,
    fontFamily: "Timmons"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 459.272,
    x: 105.058
  }, "O"))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    fontWeight: "bold",
    transform: "matrix(.8 -.3 .3 .8 337.27 11.7)",
    fontSize: 14,
    y: 455.835,
    x: -45.708,
    fontFamily: "Timmons"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 455.835,
    x: -45.708
  }, "A"))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    fontWeight: "bold",
    transform: "matrix(.6 .6 -.6 .6 337.27 11.7)",
    fontSize: 14,
    y: 144.724,
    x: 518.35,
    fontFamily: "Timmons"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 144.724,
    x: 518.35
  }, "A"))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    fontWeight: "bold",
    transform: "matrix(.84 .17 -.17 .84 337.27 11.7)",
    fontSize: 14,
    y: 388.298,
    x: 271.188,
    fontFamily: "Timmons"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 388.298,
    x: 271.188
  }, "A"))), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    fontWeight: "bold",
    transform: "matrix(.85 -.16 .16 .85 337.27 11.7)",
    fontSize: 14,
    y: 455.168,
    x: 40.322,
    fontFamily: "Timmons"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 455.168,
    x: 40.322
  }, "M"))), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    fontWeight: "bold",
    transform: "matrix(.86 -.1 .1 .86 337.27 11.7)",
    fontSize: 14,
    y: 448.079,
    x: 94.429,
    fontFamily: "Timmons"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 448.079,
    x: 94.429
  }, "P"))), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    fontWeight: "bold",
    transform: "matrix(.86 0 0 .86 337.27 11.7)",
    fontSize: 14,
    y: 437.607,
    x: 155.088,
    fontFamily: "Timmons"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 437.607,
    x: 155.088
  }, "P"))), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    fontWeight: "bold",
    transform: "matrix(.75 .42 -.42 .75 337.27 11.7)",
    fontSize: 14,
    y: 276.665,
    x: 405.134,
    fontFamily: "Timmons"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 276.665,
    x: 405.134
  }, "P"))), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    fontWeight: "bold",
    transform: "matrix(.85 .1 -.1 .85 337.27 11.7)",
    fontSize: 14,
    y: 409.793,
    x: 232.095,
    fontFamily: "Timmons"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 409.793,
    x: 232.095
  }, "I"))), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    fontWeight: "bold",
    transform: "matrix(.6 .63 -.63 .6 337.27 11.7)",
    fontSize: 14,
    y: 132.089,
    x: 530.392,
    fontFamily: "Timmons"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 132.089,
    x: 530.392
  }, "T"))), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    fontWeight: "bold",
    transform: "matrix(.7 .52 -.52 .7 337.27 11.7)",
    fontSize: 14,
    y: 218.519,
    x: 464.158,
    fontFamily: "Timmons"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 218.519,
    x: 464.158
  }, "T"))), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    fontWeight: "bold",
    transform: "matrix(.83 .24 -.24 .83 337.27 11.7)",
    fontSize: 14,
    y: 361.961,
    x: 313.725,
    fontFamily: "Timmons"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 361.961,
    x: 313.725
  }, "M"))), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    fontWeight: "bold",
    transform: "matrix(.58 .64 -.64 .58 337.27 11.7)",
    fontSize: 14,
    y: 123.248,
    x: 513.704,
    fontFamily: "Timmons"
  }, /*#__PURE__*/React.createElement("tspan", {
    y: 123.248,
    x: 513.704
  }, "G"))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M557.378 184.508s5.188-4.447 8.894-4.57m-8.145 3.952c.123-.124 31.003-4.447 31.99-5.435m-31.87 5.685c.124-.125 34.586-2.966 34.586-2.966m-34.706 3.086s36.685-1.73 38.908.123m-39.037-.243s35.944.245 36.562 1.11m-36.433-1.11l34.584 2.84m-34.954-2.592c.123 0 35.203 3.088 38.66 7.534m1.846 6.295c-.123-.123-11.98-14.205-40.638-13.958m.132.249s19.886 1.358 26.186 8.276m-25.816-8.524s12.845-2.47 26.31 13.71",
    strokeWidth: ".86pt",
    stroke: "#fff700",
    strokeLinecap: "round",
    fill: "none"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M247.4 217.74s20.718.813 20.718 2.844-15.437 5.89-15.64 14.422c-.203 8.53 11.78 9.14 12.593 19.905.814 10.767-9.342 12.39-11.374 15.235-2.03 1.422-6.906 16.656-6.296 25.593.61 8.938 3.25 39.203 7.92 45.296 3.658 2.844 9.142 11.984 15.032 9.14 5.89-2.843 1.828-13.202 1.22-16.046s2.436-7.516 2.436-11.78c0-4.267-2.234-7.72-2.03-8.735.202-1.016 16.452 3.86 15.436 19.906-1.015 16.045-7.515 11.17-7.515 11.17s2.03 19.703-3.048 22.343c-9.14 4.875-15.843-1.015-15.843-1.015l.858 4.007-6.953-3.6s-8.937-12.798-10.968-18.485-4.47-31.077-3.656-36.56c.813-5.486 1.422-37.58 1.016-39.204s-2.03-28.436-1.015-32.5c1.016-4.06 7.313-21.936 7.11-21.936z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "url(#e)",
    transform: "matrix(.86 0 0 .86 337.27 11.7)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M530.822 194.416s12.402-12.053 19.564-10.656c3.668 0 .174 2.62.174 2.62s6.29.524 7.162 3.32c.175 1.222-2.97 1.57-2.97 1.57s2.62.525 2.796 2.796-26.552.524-26.726.35z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: ".86pt",
    fill: "#ff7000"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M531.518 193.89s13.276-1.746 18.866-7.336m-5.414 3.673s9.78-.35 9.78 1.05",
    stroke: "#000",
    strokeWidth: ".86pt",
    fill: "none"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M579.73 333.116s8.385-1.92 10.655-4.89c1.4-1.05 8.735 11.004-10.655 4.89z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.075,
    fill: "#fff"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M577.46 263.766s1.048 6.463-1.923 10.83c-1.572 1.747-6.288 4.716-6.288 6.813 0 2.095 1.746 4.89 1.396 7.336s-2.97 4.89-2.795 6.987c0 2.096 2.97 13.276 2.622 13.45m-8.382-66.374s-6.636 2.27-8.034 8.91",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.075,
    fill: "none"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M559.288 190.227s2.27 6.29 9.608.35c-4.717-6.462-9.608-.175-9.608-.35z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: ".86pt",
    fill: "#c75b00"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M564.865 190.086c0 .338-.352.612-.787.612s-.786-.274-.786-.612c0-.338.352-.612.786-.612s.787.274.787.612z",
    fillRule: "evenodd"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M499.303 175.633s13.912 15.058 22.913 14.895c1.637 4.42-4.086 8.53-6.378 10.493-4.582-1.472-8.724.27-19.363-12.824.655-8.347 2.99-12.235 2.828-12.563zm18.825-35.028c1.8-5.564 5.4-9.983 8.51-10.474-.817-4.255 6.548-23.077 27.99-30.278 1.308 9.656-9.167 19.15-9.167 19.15s31.59-5.402 37.972-13.422c-.654 3.6-7.037 26.024-40.753 25.86 12.765 12.112-4.093 21.77-11.295 18.822 13.258-10.148-3.764-16.203-13.258-9.657z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: ".86pt",
    fill: "#fff"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M528.93 132.754c6.383-4.092 8.674-4.092 13.912-3.274-3.765.49-3.765.655-3.765.655s-.327.49 1.964 2.62c-2.617-.656-4.91-2.13-12.11 0z",
    fillRule: "evenodd",
    stroke: "#ccc",
    strokeWidth: ".86pt",
    fill: "#cccccd"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M526.47 130.13s12.602-6.71 19.64-11.293",
    stroke: "#000",
    strokeWidth: ".86pt",
    fill: "none"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M515.668 201.003s17.35 4.747 19.313-20.132c-3.763-10.8-9-34.042-.98-40.752-7.366-5.074-15.386.164-15.386.164-.49 1.145-7.038 10.474 1.8 26.842-20.95-5.565-12.44 14.24-12.44 14.24.82-3.11 11.95-6.057 14.73 9.82 1.147 3.927-7.527 9.983-7.036 9.82z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: ".86pt",
    fill: "#00f"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M535.147 181.034s18.33-9.82 17.84-32.898c-15.55.328-21.113 20.46-21.113 20.46l3.274 12.438z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: ".86pt",
    fill: "#00f"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M452.983 179.89s-13.585 11.785-21.277 8.02c-5.73 3.437-12.44-2.62-12.44-2.62s7.857 28.97 36.008 8.02c-.49-6.382-1.964-12.93-2.29-13.42z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: ".86pt",
    fill: "#fff"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M431.543 187.415c1.146-6.056 5.892-9 9.657-3.273 5.074.982 10.148-19.804-7.856-16.367 5.074-27.17-10.147-37.317-10.147-37.317s-5.4 30.115-2.946 35.68c2.456 5.565-3.6-10.31-23.077-14.73-.327 22.75 21.77 33.39 21.77 33.39s6.218 5.727 12.6 2.618z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: ".86pt",
    fill: "#00f"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M433.34 167.61s-8.51 7.2-6.546 17.02m-6.379-18s-1.964 7.037 2.29 17.02m-3.6 2.295s3.928-6.383 12.44 1.8",
    stroke: "#000",
    strokeWidth: ".86pt",
    fill: "none"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M420.742 141.75c0-.164-12.93 0-5.238 13.093-5.728 1.8-18.495-6.547-9.657-17.677-28.97-.654-40.754-14.566-40.754-27.332 8.51 8.838 28.806 5.237 36.008 10.638-8.837-8.184-7.037-19.476-7.037-19.476s24.715 7.365 29.133 29.296c-1.473 4.256-2.127 11.785-2.455 11.457z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: ".86pt",
    fill: "#fff"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M400.86 119.905c4.77 4.853 17.025 6.303 23.244 11.704",
    stroke: "#000",
    strokeWidth: ".86pt",
    fill: "none"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M406.503 134.224s10.145-1.31 13.085 2.292c-3.97 0-5.293-.983-11.027 1.145 1.618-.817 1.177-2.29 2.06-2.29s-3.677-1.146-4.118-1.146z",
    fillRule: "evenodd",
    stroke: "#ccc",
    strokeWidth: 0.815,
    fill: "#cccccd"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M457.077 54.843s5.564-4.91 11.62-.49c-2.736 8.174-12.603 5.072-12.603 5.072s.328 4.092-.654 6.056c1.975 1.486 3.6 6.384 3.6 6.384s10.15-2.455 12.276 1.964c3.886-.536 6.71 0 6.71 0s7.857-1.964 10.64-1.964c2.78 0 11.62 2.292 12.438 3.93.818 1.635 3.764 12.6 5.728 12.438 1.964-.164-4.746 2.618-6.546-.164-1.8-2.782-1.31 3.6-1.31 3.6s5.565 5.893 6.22 7.202c.654 1.31-3.437 11.948-.328 19.313-2.724.252-2.946 3.11-2.946 3.11-.15 3.242-4.255 4.092-4.255 4.092l-.982-4.42-2.783 1.637 1.146-3.437s3.765-9.166 4.092-12.11c.327-2.947-3.437-8.185-6.383-8.185s-5.074 9.33-5.074 9.33-1.473 7.037-.982 7.692c.492.655-1.963-2.29-1.963-2.29s-1.31 4.254-2.29 5.563c-.983 1.31-3.11 1.8-3.11 1.8s-1.474-4.255-.983-5.89c.49-1.638 8.02-8.02 7.365-12.604-.656-4.582 0-3.436-.165-3.6-.163-.163-3.928-3.437-4.09-5.237-.165-1.8-4.912 2.29-11.13.982-1.904 3.326-2.128 11.62-2.128 11.62s-.655 9.984.654 11.13c1.31 1.145-3.272 3.6-3.272 3.6l-3.274 4.42s-1.145-2.783-1.145-2.62c0 .164-2.293 1.637-2.293 1.637l1.31-3.273c-.08-2.48 3.182-9.246 3.182-14.975 0-5.73.417-11.868.417-11.868s-6.055-.328-5.892 5.892c.164 6.218-1.473 6.546-1.145 8.346.327 1.8 1.964 6.874 1.473 8.347-.49 1.473-2.455 1.964-2.455 1.964l-.49.82s-6.057 2.78-5.894 3.927c.164 1.145-.163-3.274-.163-3.274l-.327-4.746s3.6-2.292 3.6-8.02c0-5.73-.83-6.543-.665-7.852.164-1.31.993-6.06.83-6.55-.164-.492-3.437 1.308-4.42 1.308s1.8-3.437 2.128-5.892c.328-2.455-3.273 2.29-6.22-.49 1.37-3.023 3.438-3.93 3.765-6.22s-2.29 1.964-4.58.327c.185-2.196 2.454-4.092 2.454-4.092s-1.865-.228-2.62 0c-1.472-.49 1.638-2.782 1.8-6.056.165-3.273-1.8-4.582-1.8-4.746 0-.163-3.272-2.945-3.763-4.09-.49-1.146-.49-2.456-.49-2.456s-5.402 3.928-11.785-4.42c5.845-4.99 12.11-1.308 12.11-1.308s1.638-4.583 9.167-4.256c7.53.328 9.002 4.583 8.675 4.092z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: ".86pt",
    fill: "#923f00"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M498.253 139.505c.137 0 13.904.408 14.04 7.77.136 7.36-4.226 5.45-4.362 5.45s-10.086-1.225-10.086-1.225l.41-11.996z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: ".86pt",
    fill: "#00f"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M484.89 137.458s17.174-.137 16.22 7.36c-.955 7.497-5.317 5.998-5.317 5.998l-8.314-.682-2.59-12.676z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: ".86pt",
    fill: "#fffeff"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M475.214 136.64l9.95.82s5.998.816 5.725 6.54c-.273 5.726-6.135 5.863-6.135 5.863l-9.677-.546.136-12.676z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: ".86pt",
    fill: "#00f"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M451.908 139.505c-.136 0-13.904.408-14.04 7.77-.136 7.36 4.226 5.45 4.362 5.45s10.087-1.225 10.087-1.225l-.412-11.997z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: ".86pt",
    fill: "#fff"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M465.264 137.458s-17.175-.137-16.22 7.36c.954 7.497 5.315 5.998 5.315 5.998l8.314-.682 2.59-12.676z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: ".86pt",
    fill: "#00f"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M474.947 136.64l-9.95.82s-5.997.816-5.725 6.54c.273 5.726 6.134 5.863 6.134 5.863l9.678-.546-.137-12.676z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: ".86pt",
    fill: "#fff"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M501.59 219.4s7.155-10.546 10.168-9.417c2.636.88.628 9.04-.628 9.792l-9.54-.376zm-49.046 1.882c-2.26-3.138-5.523-11.8-8.536-9.415-2.636.878-.627 9.038.628 9.792l7.908-.378z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: ".86pt",
    fill: "#5e0043"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M457.283 200.427s13.942 8.59 18.516 8.812c4.572.222 19.072-11.156 19.072-11.156",
    stroke: "#000",
    strokeWidth: ".86pt",
    fill: "none"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M458.625 166.75l2.677-3.347 13.385 6.804 13.607-6.023 2.677 2.788-15.168 10.708-17.177-10.93z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: ".86pt",
    fill: "#5e0043"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M447.995 166.57c1.087 1.372 9.738 11.89 11.3 20.59 1.56 8.7-.893-11.934-.893-11.934s10.708 5.242 11.043 8.588c.334 3.346 5.12-.226 5.348-.798L443.79 162.88l4.205 3.69zm52.899-.603s-11.266 14.835-9.927 31.007c-2.324-7.744-.447-20.523-.447-20.523l-2.453 1.563s-2.566 10.93-5.8 12.604c-.546-1.302-.447-1.785-.447-1.785s-3.457 4.462-4.127 4.908c-.67.446.224 15.058.224 15.058s1.16 10.59 2.5 10.48c-1.523.745-3.393 1.903-3.393 1.903l-1.387-28.277 3.172-3.178s4.237-5.13 4.572-10.15c-1.84 1.56-3.904 2.008-3.904 2.008s-.558 7.138-2.23 8.142c-1.674 1.004-1.72 2.866-1.72 2.866l-.397-9.328 25.763-17.295z",
    fillRule: "evenodd",
    stroke: "#474747",
    strokeWidth: 1.075,
    fill: "#474747"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M475.128 183.14l2.176 44.61",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.075,
    fill: "none"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M447.694 204.443s5.13 3.012 7.027 12.158c16.73-1.226 21.974 4.686 21.974 4.686s13.72-6.58 20.077-5.354c2.23-4.685 8.59-10.708 8.59-10.708",
    stroke: "#000",
    strokeWidth: ".86pt",
    fill: "none"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M440.694 160.72l34.438 22.532 31.008-20.858s6.47-3.57 5.912-6.134-2.788-1.562-3.904-1.116c-1.115.447-32.458 22.642-32.458 22.642l-33.35-21.08s-2.454-.78-2.9.78.92 2.455 1.253 3.235z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: ".86pt",
    fill: "#b4b6b9"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M502.278 154.873s-8.81-3.74-8.81-.5c0 3.243.248 3.575 1.66 5.654 1.414 2.078-1.08 3.408-1.08 3.408s-.332-.914-.83-2.328c-.5-1.413-5.238-2.41-5.653-4.073-.416-1.662.997-4.323-1.83-4.655-2.826-.334-5.57 1.163-6.15 4.405-.583 3.242-4.24 10.807-4.24 10.807l.5-17.208c6.205.443 17.733 1.8 26.6 2.826-2.66-.415.997.166.914 1.08-.25.75-1.165.832-1.082.583zm-31.175-4.326c-1.58 0-9.476.915-11.47 2.078-1.996 1.164 3.24 2.993 2.576 4.572-.666 1.58-.75 4.74-3.243 4.074-2.494-.664-10.89-4.82-11.14-6.234-.248-1.413-1.994-1.496-1.994-1.496s24.107-3.242 25.27-2.993z",
    fillRule: "evenodd",
    stroke: "#474747",
    strokeWidth: 1.075,
    fill: "#474747"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M474.904 148.57l-.06 21.14m-16.219-46.047s-9.66 15.684-9.85 16.162",
    stroke: "#000",
    strokeWidth: ".86pt",
    fill: "none"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M161.8 129.74s4.893 6.672 4.337 8.562c2 1.557 4.225 7.784 4.225 7.784",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "url(#f)",
    transform: "matrix(.86 0 0 .86 337.27 11.7)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M492.672 122.322s-9.085 12.815-8.798 13.77",
    stroke: "#000",
    strokeWidth: ".86pt",
    fill: "none"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M446.213 61.426c-.206.717-1.364.995-2.588.62s-2.048-1.26-1.842-1.976c.206-.717 1.365-.995 2.588-.62s2.05 1.26 1.843 1.976zm3.673-.253c.206.717 1.364.995 2.588.62s2.047-1.26 1.842-1.976c-.206-.717-1.365-.995-2.588-.62s-2.048 1.26-1.842 1.976z",
    fillRule: "evenodd"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M556.13 326.572s-3.367.63-3.262.947-9.79.63-10 .315c-.212-.316-1.475 1.684-1.475 1.684l1.58-.948s2.42 2.527 3.158 2.316c.737-.21-.315.947-.105 1.158.21.21.948-.42.948-.42l16.36-.275-7.2-4.778z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: ".86pt",
    fill: "#ff7000"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M562.23 331.663l-13.363.387s-3.37 3.053-3.58 3.79 2.21.947 2.21.947l.738 2.527 1.685-.632s11.36 1.69 21.79-.632c5.265-1.842 6.186-4.053 2.5-5.395-3.683-1.342-11.876-.94-11.98-.992z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.075,
    fill: "#ff7000"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M208.37 403.93l27.97-1.246-5.208-4.416 75.647-3.058-2.606-6.002-84.707 3.398 10.192 4.756-22.876.68.68 2.377-6.002-.227s6.68 2.605 6.908 3.737z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "url(#g)",
    transform: "matrix(.86 0 0 .86 337.27 11.7)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M239.73 249.42c-2.222-1.11-11.998-2.444-22.884 4.666l.444 25.106s15.997-8.665 23.773-6.666c-.444-7.776-.444-17.774-1.333-23.106z",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: "1pt",
    fill: "url(#h)",
    transform: "matrix(.86 0 0 .86 337.27 11.7)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M410.434 291.76l-56.723 56.31m82.003-55.898l-46.037 60.63m43.983-76.454l-61.453 74.398m-1.849-1.032l5.96-6.987m69.054-28.977l-23.84 32.886m-1.029 4.317l.617 12.53m35.14-38.227l-25.278 31.65m20.763-2.462l10.276-16.852m-6.371-3.289l-12.332 13.975m8.632-27.124l-8.425 10.276m-2.47-25.283s-25.69 37.61-25.278 40.692m22.603-45.619c-.616.41-22.196 28.977-22.196 28.977m-1.229 9.033l-3.905 4.728m-4.933 7.202l-5.96 7.808",
    stroke: "#000",
    strokeWidth: ".86pt",
    fill: "none"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M407.627 205.2s-1.74 5.47 0 8.204 12.68 24.86 12.68 24.86 7.458-9.197 10.193-9.446c2.735-.248 1.49 23.867 1.49 23.867s-4.473 4.227-7.208 3.978c-2.735-.248 6.712 9.447 6.464 17.652s-12.43 48.976-16.906 49.722c-4.475.746 1.99-7.458 1.74-9.696-.25-2.236-1.492-.745-2.486-3.23-.995-2.487 1.492-6.216.994-8.702s-2.734-1.99-2.983-3.73 1.492-2.237 1.243-4.225c-.25-1.99-2.983-1.493-2.735-3.233.25-1.74.498-.994.25-4.226-.25-3.232-.747 2.237-3.482 2.486-2.733.25-4.97 6.464-4.97 6.464s-5.47 7.707-10.94 4.226c3.232 6.96.746 9.945-.497 10.193s.994 5.47-1.99 5.72 2.238 11.683-1.242 12.677c3.73 1.74.747 3.98.747 3.98s-8.618.715-6.713 11.932c-25.36-8.935-37.79-24.346-37.54-40.007.248-15.662 5.22-29.833 17.402-35.054 3.48-12.928 9.447-26.85 9.447-26.85s-.994-5.718-.248-9.447c.746-3.73 4.226-7.458 4.226-7.458s-.496-8.95-.247-13.425c.248-4.475 1.99-6.465 2.237-8.95.25-2.486-.746-15.166 1.74-17.403 2.487-2.238 7.21-1.99 9.696-3.48 2.486-1.492 5.718-4.227 8.95-3.98s5.967 2.488 5.967 2.488 12.182 0 12.927 4.724c.746 4.722-2.486 6.462-2.486 6.462s1.74 6.713-5.718 12.928z",
    fillRule: "evenodd",
    stroke: "#2b2b2b",
    strokeWidth: ".86pt",
    fill: "#8a9396"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M396.852 188.097c.39.722-.5 1.96-1.986 2.764s-3.01.875-3.4.153c-.39-.72.498-1.958 1.986-2.764s3.01-.874 3.4-.153z",
    fillRule: "evenodd",
    stroke: "#2b2b2b",
    strokeWidth: 1.147,
    fill: "#cecfcf"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M394.787 189.354c0 .455-.414.824-.925.824-.51 0-.924-.37-.924-.824 0-.454.414-.823.924-.823s.925.37.925.824z",
    fillRule: "evenodd"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M412.925 197.46s3.02 13.48-.59 22.793m1.519-28.693s5.89 7.792 5.13 17.483m-4.56-19.193c.19 0 4.94 4.18 4.75 7.03m-3.61-8.742s3.23 2.28 3.99 4.56",
    stroke: "#2b2b2b",
    strokeWidth: 0.537,
    fill: "none"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M414.044 186.805s-11.592 18.813-10.072 30.595",
    stroke: "#000",
    strokeWidth: ".86pt",
    fill: "none"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M414.804 186.237s-15.393 9.122-18.243 38.957",
    stroke: "#2b2b2b",
    strokeWidth: 0.537,
    fill: "none"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M413.094 191.75l-6.082 4.56",
    stroke: "#000",
    strokeWidth: ".86pt",
    fill: "none"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M390.86 226.906s8.552-35.537 23.754-40.667",
    stroke: "#2b2b2b",
    strokeWidth: 0.537,
    fill: "none"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M420.505 238.878s8.172-10.262 10.072-9.882c1.9.38 1.33 23.754 1.33 23.754s-6.08 4.56-7.412 4.37c-1.33-.19 6.842 11.023 6.652 15.204-.19 4.18-.38 4.18-.38 4.18s0-2.47-1.9-6.46c-1.9-3.99-.76-8.552-13.113-18.624-3.04-6.27 6.08 3.8 7.98 2.28 1.902-1.52-3.42-14.632-3.23-14.822z",
    fillRule: "evenodd",
    stroke: "#2b2b2b",
    strokeWidth: ".86pt",
    fill: "#2b2b2b"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M405.978 181.086s-3.435.936-3.904 2.342c-.468 1.405-2.498 2.81-3.59 2.342-1.094-.468-3.125-2.186-3.125-2.186",
    stroke: "#2b2b2b",
    strokeWidth: ".86pt",
    fill: "none"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M386.46 193.108s-5.155 5.154-2.656 5.778c2.498.625 5.153-4.06 5.153-4.06s0 7.964 2.186 6.715 8.59-5.777 8.59-5.777 2.185-.156 2.653 0c.47.156 5.934 4.84 9.526 3.123-2.03 5.31-4.373 5.934-4.373 5.934s-3.748 4.84-8.59 3.748c-4.84-1.093-6.09-3.123-6.09-3.123s-4.06.312-5.308-1.562c-1.25-1.874-1.718-2.967-1.718-2.967s-2.342 2.343-2.967 1.25c-.625-1.094 0-7.496 3.59-9.057z",
    fillRule: "evenodd",
    stroke: "#2b2b2b",
    strokeWidth: 1.075,
    fill: "#2b2b2b"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M415.66 185.927s-9.526-2.81-12.805 1.874c-3.28 4.686-2.498 7.34-.78 7.81",
    stroke: "#2b2b2b",
    strokeWidth: ".86pt",
    fill: "none"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M417.13 185.66c0 1.124-.804 2.034-1.796 2.034s-1.796-.91-1.796-2.033.804-2.033 1.796-2.033 1.796.91 1.796 2.034z",
    fillRule: "evenodd"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M389.407 209.964s3.884 5.976 8.515 7.62-3.212 3.062-7.843-.075c-3.362-4.558-2.466-7.844-2.466-7.844s.896-.897 1.793.298zm33.24 35.26s-10.906-15.162-14.043-15.984c-3.138-.822 2.39-1.494 5.75 1.718 3.362 3.212-.895-5.23-.895-5.23l9.186 19.496z",
    fillRule: "evenodd",
    stroke: "#2b2b2b",
    strokeWidth: ".86pt",
    fill: "#2b2b2b"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M388.362 332.84c4.183-1.12 22.408 10.46 26.516 13.372 4.108 2.913 12.698 1.045 12.698 1.045s-3.96 2.39-6.424 2.988 7.32.598 7.32.598-23.305 6.423-46.983-6.05c-2.167-9.71 5.078-11.877 6.87-11.952z",
    fillRule: "evenodd",
    stroke: "#2b2b2b",
    strokeWidth: 1.075,
    fill: "#2b2b2b"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M415.028 248.957s-3.063-.598-4.63-2.39c-1.57-1.793-3.81-6.2-6.126-8.068s-13.894-8.217-18.077-7.77c-4.183.45-5.452-.447-5.975-.97-.523-.523-2.24.224-1.942 2.39.298 2.167-3.212 6.947-1.942 9.188 1.27 2.24 7.245 11.353 8.44 11.652 1.195.3.448 5.303.448 5.303s5.304 5.378 6.648 5.677c1.345.3 2.69 1.27 2.54 2.54-.15 1.27-5.826 8.216-5.826 8.216s-6.125 3.212-6.2 5.005c-.075 1.793 1.494 5.528 6.35 6.723 4.854 1.195 17.926.224 18.598-.896.672-1.12 1.718-7.843 1.27-8.515-.448-.673-3.66-2.69-5.303-2.39-1.643.298-3.137 1.643-2.987 1.94.15.3-2.316 1.57-2.316.375s4.855-6.573 5.304-6.125c.45.448 7.32 1.12 8.59 4.556s1.27 5.9 4.856 5.528c3.585-.374 8.59-3.66 9.037-10.532.45-6.872-4.033-11.503-5.154-12.175-1.12-.673-4.856-2.914-5.155-3.96-.298-1.045-1.045-4.48-.448-5.303z",
    fillRule: "evenodd",
    stroke: "#2b2b2b",
    strokeWidth: ".86pt",
    fill: "#2b2b2b"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M350.416 279.29s11.577-2.99 14.566-2.914c2.988.075 14.266 5.303 17.553 8.515 3.287 3.213 10.01 10.832 14.416 10.16 4.408-.673 5.678-1.57 5.678-1.57l-1.718 3.287s-3.585.97-5.378.523c-1.792-.448-5.303-1.568-8.814-5.004-3.51-3.436-14.34-12.698-23.53-12.026-9.186.672-14.49 9.71-14.49 9.71s.075-4.407.45-5.378c.372-.97-1.944 2.09-1.944 2.09l3.212-7.394z",
    fillRule: "evenodd",
    stroke: "#2b2b2b",
    strokeWidth: ".86pt",
    fill: "#2b2b2b"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M393.067 288.25c.074.075 2.913.822 7.693.822s7.32-2.092 7.32-2.092l-.298-1.867.747-2.614s3.66 3.733 3.584 4.48c-.075.747-1.494 1.046-1.494 1.046l-.523-1.793-1.27 1.57s-6.946 5.526-10.756 4.705c-3.808-.822-7.32-3.287-6.348-3.884s1.494-.374 1.345-.374zm-16.881 9.787s-4.183-.075-6.05.822c-1.868.895-2.54 2.015-3.81 1.866-1.27-.15-2.24-1.793-1.867-2.465.522-1.045 2.987-2.39 7.692-2.016s4.034 1.793 4.034 1.793zm14.641 11.353c0-.225-.3-6.126-2.615-8.516s-5.154-2.39-6.424-2.092c-1.27.3 4.706 2.913 5.304 4.63.597 1.72 2.54 6.5 2.017 7.695-.524 1.195-1.495-3.36-5.155-4.63s-8.74-.6-7.694 1.045 5.155.15 7.246 3.66 3.66 7.245 3.66 7.245l.673-2.54 1.866-.522.224-4.856.897-1.12z",
    fillRule: "evenodd",
    stroke: "#2b2b2b",
    strokeWidth: ".86pt",
    fill: "#2b2b2b"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M387.84 328.507l-3.81-7.62s-1.196-4.854-4.408-6.2c-3.212-1.343-7.47-1.12-7.544.524-.074 1.644 6.872 3.736 7.32 4.632.45.897.224 2.39-.373 2.465-.598.075-3.66-1.12-5.23-.747-1.567.374-2.464 2.39-4.78 1.793-2.315-.598-4.257-7.993-3.36-8.74.896-.746-1.718 1.345-2.24-.597-.524-1.942.746-7.992-.15-8.74-.897-.746-5.23-3.36-5.304-3.883-.074-.523.225-29.73 24.65-5.528-10.457-12.4-14.566-11.054-16.507-11.13-1.42 0-10.906.822-13.296 12.923-2.39 12.1-5.23 4.557-5.23 4.557s-.522 5.228 2.018 6.722c2.54 1.494-1.195 5.826-1.195 5.826s-4.556-11.13-3.884-15.985c-.897 3.885-.822 13.52 4.93 24.052 6.722 7.096 13.072 13.67 29.953 21.064 8.888-13.595 8.44-15.237 8.44-15.387z",
    fillRule: "evenodd",
    stroke: "#2b2b2b",
    strokeWidth: 1.075,
    fill: "#2b2b2b"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M371.854 328.584s4.93.598 6.274 3.137c1.345 2.54 1.942 6.425 1.942 6.425.822-1.643 1.196-3.062 2.84-4.257s2.837-1.345 2.763-2.24c-.075-.898-5.23-6.35-7.843-6.65-2.615-.298-7.17 2.84-7.17 2.84s-.823 1.194 1.194.746z",
    fillRule: "evenodd",
    stroke: "#2b2b2b",
    strokeWidth: 1.075,
    fill: "#8a9396"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M383.114 341.433s12.776 5.824 33.82 6.2",
    stroke: "#8a9396",
    strokeLinecap: "round",
    strokeWidth: 1.075,
    fill: "none"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M425.764 282.127s-1.1 10.72-9.345 31.88",
    stroke: "#2b2b2b",
    strokeLinecap: "round",
    strokeWidth: 1.075,
    fill: "none"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M424.12 288.723s-2.472 7.696-9.343 13.467",
    stroke: "#2b2b2b",
    strokeWidth: ".86pt",
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGs);
export default __webpack_public_path__ + "static/media/gs.dc8be5df76739c6303f34f0b099c7e13.svg";
export { ForwardRef as ReactComponent };